import axios from 'axios';

// Create axios instance
const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
  
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      //console.log('API Request - Authorization header added');
    } else {
   //   console.log('API Request - No auth token found');
    }
    return config;
  },
  (error) => {
    console.error('API Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor only for auth errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors only
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userInfo');
      window.dispatchEvent(new CustomEvent('auth-logout'));
      if (!window.location.pathname.includes('/login')) {
        console.log('401 Unauthorized - redirecting to login');
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Read an SSE stream from a fetch response.
 * Calls onToken for each streamed token, onDone with final metadata, onError on failure.
 */
export async function readSSEStream(response, { onToken, onDone, onError, onStatus }) {
  if (!response.ok) {
    try {
      const err = await response.json();
      onError(err.message || `HTTP ${response.status}`);
    } catch {
      onError(`HTTP ${response.status}`);
    }
    return;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop(); // keep incomplete last line
      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        try {
          const data = JSON.parse(line.slice(6));
          if (data.token !== undefined) { console.log('[SSE-client] token:', JSON.stringify(data.token).substring(0, 30)); onToken(data.token); }
          else if (data.done) { console.log('[SSE-client] done'); onDone(data); }
          else if (data.error) { console.log('[SSE-client] error:', data.error); onError(data.error); }
          else if (data.status) { console.log('[SSE-client] status:', data.status); onStatus?.(data.status); }
        } catch { /* malformed line — skip */ }
      }
    }
  } catch (err) {
    onError(err.message || 'Stream read error');
  }
}

/** Returns the auth header value from localStorage */
export function getAuthHeader() {
  const token = localStorage.getItem('authToken');
  return token ? `Bearer ${token}` : '';
}

export default apiClient;
